import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useTranslation } from '../../../contexts/TranslationContext';
import {
  type DeviceHeader,
  devicesSortingAtom,
} from '../../../models/atoms/device_atoms';
import { MHMTypography } from '../MHM/MHMTypography';
import { Order } from '../../../utils/sorting_helpers';
import { MHMSortIcon } from '../MHM/MHMSortIcon';
import type { TableHeader } from './DeviceList';

type Props = {
  headers: TableHeader[];
};

export function DevicesTableHead({ headers }: Props) {
  const { t } = useTranslation();
  const [{ sortBy, sortDirection }, setSortingState] =
    useRecoilState(devicesSortingAtom);

  function updateSorting(sortBy: DeviceHeader) {
    setSortingState(prev => {
      let sortDirection: Order = 'asc';
      if (sortBy === prev.sortBy) {
        sortDirection = prev.sortDirection === 'asc' ? 'desc' : 'asc';
      }

      return { sortBy, sortDirection };
    });
  }

  return (
    <TableHead>
      <TableRow>
        {headers.map(header => {
          const isActive = header.sort && sortBy === header.key;
          const direction: Order = isActive ? sortDirection : 'asc';

          return (
            <TableCell
              key={header.key}
              align="center"
              sortDirection={isActive ? direction : false}
              sx={{ bgcolor: 'background.paper' }}
            >
              <TableSortLabel
                active={isActive}
                hideSortIcon={!header.sort}
                direction={direction}
                IconComponent={() => (
                  <MHMSortIcon order={isActive ? direction : undefined} />
                )}
                onClick={() => updateSorting(header.key)}
              >
                <MHMTypography bold>{t(header.label)}</MHMTypography>
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
